import * as types from "../types/performance.types";
import moment from "moment";

const initialState = {
  performanceData: [],
  performancePagination: [],
  performanceFilter: {
    page: 1,
    limit: 10,
    date: [moment(), moment()],
  },
  performanceLoader: false,
};

const PerformanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_PERFORMANCE_LIST_DATA:
      return { ...state, performanceData: action.payload };
    case types.SET_PERFORMANCE_LIST_PAGINATION:
      return { ...state, performancePagination: action.payload };
    case types.SET_PERFORMANCE_LIST_FILTER:
      return { ...state, performanceFilter: action.payload };
    case types.SET_PERFORMANCE_LOADER:
      return { ...state, performanceLoader: action.payload };
    case types.RESET_PERFORMANCE_REDUCER:
      return { 
        ...state, 
        performanceData: [],
        performancePagination: [],    
        performanceFilter: initialState.performanceFilter,
      };
    default:
      return state;
  }
};
export default PerformanceReducer;
